import * as React from "react";
import { useCallback, useState } from "react";
import * as Immutable from "immutable";
import useParams from "routing/useParams";
import useExportData from "export/useExportData";
import { Spinner, Timestamp } from "components/common";
import { RenderCompletionObserver } from "components/visualizations";
import { Container, InvisibleDiv } from "export/Components";
import EventsHistogram from "components/events/EventsHistogram";
import EventsCategoriesHistogram from "security-app/components/SecurityEvents/Alerts/MitreCategories/EventsCategoriesHistogram";
import useUserDateTime from "hooks/useUserDateTime";
import SecurityEventsHistogram from "security-app/components/SecurityEvents/Alerts/SecurityEventsHistogram";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import ExportErrorBoundary from "export/ExportErrorBoundary";
import { getExportWidgetSizes } from "search/ExportWidgetAction/util/WidgetExportUtils";
const dispatchHistogramComponent = (renderType) => {
  switch (renderType) {
    case "EVENTS_HISTOGRAM":
      return EventsHistogram;
    case "SECURITY_EVENTS_HISTOGRAM":
      return SecurityEventsHistogram;
    case "MITRE_CATEGORY_HISTOGRAM":
      return EventsCategoriesHistogram;
    default:
      throw new Error(`Invalid render type: ${renderType}`);
  }
};
const histogramHeadline = (renderType) => {
  switch (renderType) {
    case "EVENTS_HISTOGRAM":
    case "SECURITY_EVENTS_HISTOGRAM":
      return "Alerts & Events over Time";
    case "MITRE_CATEGORY_HISTOGRAM":
      return "Mitre Att&ck Tactics/Techniques Distribution";
    default:
      throw new Error(`Invalid render type: ${renderType}`);
  }
};
const EventsMetricsExportPage = () => {
  var _a, _b, _c, _d, _e, _f;
  const { userTimezone } = useUserDateTime();
  const { exportCallId } = useParams();
  const { isFetching, data } = useExportData(exportCallId);
  const [isRenderComplete, setIsRenderComplete] = useState(false);
  const handleRenderComplete = useCallback(() => {
    setIsRenderComplete(true);
  }, []);
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const rawSearchParameters = data.widget.search_parameters;
  const searchParams = {
    ...rawSearchParameters,
    query: (_a = rawSearchParameters.query) != null ? _a : "",
    filters: Immutable.Map(rawSearchParameters.filters)
  };
  const Histogram = dispatchHistogramComponent(data.widget.renderType);
  const headline = histogramHeadline(data.widget.renderType);
  const { width } = getExportWidgetSizes(
    (_c = (_b = data.widget) == null ? void 0 : _b.position) == null ? void 0 : _c.height,
    (_e = (_d = data.widget) == null ? void 0 : _d.position) == null ? void 0 : _e.width,
    (_f = data.widget) == null ? void 0 : _f.orientation
  );
  return /* @__PURE__ */ React.createElement(Container, { $width: width }, /* @__PURE__ */ React.createElement(RenderCompletionObserver, { onRenderComplete: handleRenderComplete }, /* @__PURE__ */ React.createElement(ExportErrorBoundary, null, /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "disabled" }, /* @__PURE__ */ React.createElement("h2", null, headline), /* @__PURE__ */ React.createElement(Histogram, { searchParams, setFilters: () => {
  } }), /* @__PURE__ */ React.createElement("p", null, "Created at ", /* @__PURE__ */ React.createElement(Timestamp, { dateTime: /* @__PURE__ */ new Date() }), " (", userTimezone, ")")))), /* @__PURE__ */ React.createElement(InvisibleDiv, { id: "render-started" }), isRenderComplete && /* @__PURE__ */ React.createElement(InvisibleDiv, { id: "render-complete" }));
};
export default EventsMetricsExportPage;
